<template>
   <v-container fluid grid-list-xl py-0>
			<v-layout row wrap>
				<app-card
					:heading="$t('message.appointments')"
					:fullBlock="true"
					colClasses="xl12 lg12 md12 sm12 xs12"
				>
					
					<v-data-table
						v-bind:headers="headersAppoints"
						v-bind:items="this.record.Appointments"
					>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.DateInfo }}</td>
                            <td>{{ props.item.Descr }}</td>
							<td>{{ props.item.UserName }}</td>
                            <td>{{ props.item.Information }}</td>
                        
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>
			</v-layout>

  	</v-container>


</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

export default {
  props: {
      record : Object
  },
   components: {
  },
   mounted() {
  },
  data() {
    return {
        currentRec : '',
		dialog4 : false,
		headersAppoints: [
			{ text: "Datum", value:"Date"},
			{ text: "Behandeling", value:"Service"},
			{ text: "Medewerker / Ruimte", value:"User"},
			{ text: "Informatie", value:"Info"}
		],
    }
  },
   methods: {
      
  }
};
</script>
